module.exports = __webpack_public_path__ + "static/media/nsw-government.1e4306ab.png";